import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class SureDialog extends React.Component {
	render() {
		const {
			title,
			message,
			onAgree,
			onDisagree,
			triggered,
			onAgreeText
		} = this.props;
		return (
			<Dialog
				open={triggered !== undefined ? triggered : false}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					{onDisagree && (
						<Button onClick={onDisagree} color="primary">
							No, go back
						</Button>
					)}
					<Button onClick={onAgree} color="primary" autoFocus>
						{onAgreeText ? onAgreeText : "Yes"}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

export default SureDialog;
